
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import {
  ChatInterface,
  NoteCreateInterface,
  ProfileMapInterface,
} from '@/services/QC-V2/chat/interfaces';
import { NoteRepositoryInterface } from '@/services/QC-V2/note/interfaces';
import DeleteNoteDialog from '@/components/dialogs/qc-v2/note/DeleteNoteDialog.vue';

@Component({
  components: { DeleteNoteDialog },
  mixins: [
    Themeable,
  ],
  inject: [
    'noteRepositoryV2',
  ],
})
export default class ChatPrivateNotes extends Vue {
  @Prop() private chat!: ChatInterface;
  @Prop() private profilesMap!: ProfileMapInterface;
  @Prop({ default: false }) private initiallyCollapsed: boolean;
  @Prop({ default: false }) private disabledNotes: boolean;

  private collapsed: boolean = false;

  private noteRepositoryV2!: NoteRepositoryInterface;

  private loading: boolean = true;

  private note: string = '';

  private noteIdForEdit: number = 0;
  private editNoteText: string = '';

  private deleteNoteDialogVisible: boolean = false;
  private deleteNoteDialogEvent!: string;
  private deleteNoteDialogData!: { chatId?: string, noteId?: number };

  private async created(): Promise<void> {
    this.collapsed = this.initiallyCollapsed;
    const [firstName, lastName] = this.$store.getters.name.split(' ');
    this.profilesMap[this.$store.getters.id] = {
      userId: this.$store.getters.id,
      profileId: '',
      firstName,
      lastName,
      fullName: `${firstName} ${lastName}`,
    };
    this.loading = false;
  }

  @Watch('chat')
  private async reloadData(): Promise<void> {
    this.loading = true;
    this.loading = false;
  }

  private async createNote(): Promise<void> {
    this.note = this.note.trim();
    if (!this.note) {
      return;
    }

    const noteData: NoteCreateInterface = {
      author: this.$store.getters.id,
      text: this.note,
    };

    try {
      const note = await this.noteRepositoryV2.createChatNote(this.chat.id, noteData);
      this.$successDialog.show('Note Created Successfully!');
      this.chat.notes.push(note);
      this.note = '';
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }

  private showDeleteNoteDialog(chatId: string, noteId: number): void {
    this.deleteNoteDialogData = { chatId, noteId };
    this.deleteNoteDialogEvent = 'note-deleted';
    this.deleteNoteDialogVisible = true;
  }

  private async deleteNote(data: { chatId: string, noteId: number }): Promise<void> {
    try {
      await this.noteRepositoryV2.deleteChatNote(data.chatId, data.noteId);
      this.$successDialog.show('Note Deleted Successfully!');
      this.chat.notes = this.chat.notes.filter((note) => note.id !== data.noteId);
      this.deleteNoteDialogVisible = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }

  private showEditBox(noteId: number, noteText: string): void {
    if (this.noteIdForEdit === noteId) {
      this.editNoteText = '';
      this.noteIdForEdit = 0;
      return;
    }

    this.editNoteText = noteText;
    this.noteIdForEdit = noteId;
  }

  private async editNote(chatId: string, noteId: number, noteIndex: number): Promise<void> {
    try {
      const noteData: NoteCreateInterface = {
        author: this.$store.getters.id,
        text: this.editNoteText,
      };

      await this.noteRepositoryV2.updateChatNote(chatId, noteId, noteData);
      this.$successDialog.show('Note Updated Successfully!');
      this.chat.notes[noteIndex].text = this.editNoteText;

      this.noteIdForEdit = 0;
      this.editNoteText = '';
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }
}
